import { isNil } from "lodash";

export default class NumberUtil {
  public static roundNumber(number: number | undefined | null) {
    if (isNil(number)) {
      return number;
    }

    return number ? Math.round(number * 100) / 100 : 0;
  }

  public static numberToString(num: number) {
    if (num) {
      return String(num);
    }
  }

  public static numberToLetter(number: number): string {
    return String.fromCharCode(97 + number).toUpperCase();
  }
}

export // put this in a utils file once
const normalizeDigits = (value: string = "") => {
  // Arabic-Indic (٠-٩) U+0660–0669  and Eastern Arabic-Indic (۰-۹) U+06F0–06F9
  return value
    .replace(/[\u0660-\u0669]/g, (d) =>
      String.fromCharCode(d.charCodeAt(0) - 0x0660 + 48)
    )
    .replace(/[\u06F0-\u06F9]/g, (d) =>
      String.fromCharCode(d.charCodeAt(0) - 0x06f0 + 48)
    );
};
